import React, { useState } from 'react';
import styles from './Recruitment.module.scss';

const RenderListItemObjective = ({list}) => {
  const [showReadmore, setShowReadmore] = useState(false);
  
  if (!list || list.length === 0) return null;

  if (list.length < 2) {
    return (
      <ul>
        {list.map((item, index) => {
          return (
            <li key={index} className={styles.descriptionItem}>{item}</li>
          )
        })}
      </ul>
    );
  };

  const listShow = list.slice(0, 1);
  const listHide = showReadmore ? list.slice(1, list.length) : [];

  return (
    <ul>
      {listShow.map((item, index) => {
        return (
          <li key={index} className={styles.descriptionItem}>{item}</li>
        )
      })}
      <li style={showReadmore ? {display: 'none'} : {}}>
        <div 
          onClick={() => setShowReadmore(true)}
          className={styles.readmore}
        >
          ...Xem thêm
        </div>
      </li>
      {listHide.map((item, index) => {
        return (
          <li key={index} className={styles.descriptionItem}>{item}</li>
        )
      })}
    </ul>
  );
};
export default RenderListItemObjective;